const hasValueNonZero = obj => {
  return Object.values(obj).some(value => +value !== 0);
};

const getPricingFromField = (field, orderDataValue) => {
  const totals = {
    monthly: 0,
    oneTime: 0,
    threeYearEasyPayment: 0,
    fiveYearEasyPayment: 0
  };

  if (
    (!field || Object.keys(field).length === 0) &&
    orderDataValue &&
    hasValueNonZero(orderDataValue)
  )
    return orderDataValue;
  if (!field || Object.keys(field).length === 0) return totals;

  switch (field.type) {
    case 'MultiCheckbox':
      (field.options || []).forEach(option => {
        if ((field.value || []).includes(option.fields.value)) {
          totals.monthly += option.fields.monthlyPayment || 0;
          totals.oneTime += option.fields.oneTimePrice || 0;
          totals.threeYearEasyPayment +=
            option.fields.threeYearEasyPayment || 0;
          totals.fiveYearEasyPayment += option.fields.fiveYearEasyPayment || 0;
        }
      });
      break;

    case 'PlusMinusInput':
      totals.monthly += field.monthlyPayment * +field.value || 0;
      totals.oneTime += field.oneTimePrice * +field.value || 0;
      totals.threeYearEasyPayment +=
        field.threeYearEasyPayment * +field.value || 0;
      totals.fiveYearEasyPayment +=
        field.fiveYearEasyPayment * +field.value || 0;
      break;

    case 'Number':
      totals.monthly += (field.monthlyPayment || 0) * +field.value || 0;
      totals.oneTime += (field.oneTimePrice || 0) * +field.value || 0;
      totals.threeYearEasyPayment +=
        (field.threeYearEasyPayment || 0) * +field.value || 0;
      totals.fiveYearEasyPayment +=
        (field.fiveYearEasyPayment || 0) * +field.value || 0;
      break;

    case 'Money':
      totals.monthly += field.monthlyPayment || 0;
      totals.oneTime += field.oneTimePrice || 0;
      totals.threeYearEasyPayment += field.threeYearEasyPayment || 0;
      totals.fiveYearEasyPayment += field.fiveYearEasyPayment || 0;
      break;

    case 'Radio':
      (field.options || []).forEach(option => {
        if ((field.value || []).includes(option.fields.value)) {
          totals.monthly += option.fields.monthlyPayment || 0;
          totals.oneTime += option.fields.oneTimePrice || 0;
          totals.threeYearEasyPayment +=
            option.fields.threeYearEasyPayment || 0;
          totals.fiveYearEasyPayment += option.fields.fiveYearEasyPayment || 0;
        }
      });
      break;

    case 'CouponBasedDiscount':
      if (field && field.redeemOfferAdjustedTotalPrice) {
        totals.monthly =
          -field.redeemOfferAdjustedTotalPrice.monthlyPrice || 0;
        totals.oneTime =
          -field.redeemOfferAdjustedTotalPrice.oneTimePrice || 0;
      }
      break;

    default:
      break;
  }
  return totals;
};

export default getPricingFromField;
